import { render } from "./ParticipantMessages.vue?vue&type=template&id=5dee0cde&scoped=true"
import script from "./ParticipantMessages.vue?vue&type=script&lang=js"
export * from "./ParticipantMessages.vue?vue&type=script&lang=js"

import "./ParticipantMessages.vue?vue&type=style&index=0&id=5dee0cde&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dee0cde"]])

export default __exports__